import axios, { AxiosError } from "axios"
import { firebaseauth } from "../mp-database/firebaseConfig"
import { getEnv } from "../../utils/env"

const cubeClient = new axios.Axios({
  baseURL: `${getEnv("BASE_REPORTING_API")}/cube/load`,
  responseType: "json"
})

function getStackFrame(n) {
    // Try V8-based approach first (Chrome, Edge, Node.js)
    if (typeof Error.captureStackTrace === 'function' && typeof Error.prepareStackTrace === 'function') {
        const originalPrepare = Error.prepareStackTrace;
        Error.prepareStackTrace = (_, stack) => stack;
        const obj = {};
        Error.captureStackTrace(obj);
        const structuredStack = obj.stack;
        Error.prepareStackTrace = originalPrepare;
        return structuredStack.slice(1);
    }

    // Fallback: parse Error.stack string for Firefox, Safari, Edge legacy
    const error = new Error();
    const stack = error.stack || '';
    const lines = stack.split('\n').slice(2); // Skip "Error" and "getStackFrame" lines

    return lines.map(line => {
        const stackFrame: any = {};

        // Parse different stack trace formats
        // Firefox format: functionName@filename:line:column or @filename:line:column
        // Safari format: functionName@filename:line:column or global code@filename:line:column
        // Edge format: similar to Chrome but falls back to stack string

        const firefoxMatch = line.match(/^(.+?)@(.+):(\d+):(\d+)$/);
        if (firefoxMatch) {
            stackFrame.getFunctionName = () => firefoxMatch[1] === '' ? null : firefoxMatch[1];
            stackFrame.getFileName = () => firefoxMatch[2];
            stackFrame.getLineNumber = () => parseInt(firefoxMatch[3], 10);
            stackFrame.getColumnNumber = () => parseInt(firefoxMatch[4], 10);
            return stackFrame;
        }

        // Chrome/Edge stack format: at functionName (filename:line:column)
        const chromeMatch = line.match(/at (.+?) \((.+):(\d+):(\d+)\)$/) || line.match(/at (.+) \((.+):(\d+):(\d+)\)$/);
        if (chromeMatch) {
            stackFrame.getFunctionName = () => chromeMatch[1] === '' ? null : chromeMatch[1];
            stackFrame.getFileName = () => chromeMatch[2];
            stackFrame.getLineNumber = () => parseInt(chromeMatch[3], 10);
            stackFrame.getColumnNumber = () => parseInt(chromeMatch[4], 10);
            return stackFrame;
        }

        // Simple format: at filename:line:column
        const simpleMatch = line.match(/at (.+):(\d+):(\d+)$/);
        if (simpleMatch) {
            stackFrame.getFunctionName = () => null;
            stackFrame.getFileName = () => simpleMatch[1];
            stackFrame.getLineNumber = () => parseInt(simpleMatch[2], 10);
            stackFrame.getColumnNumber = () => parseInt(simpleMatch[3], 10);
            return stackFrame;
        }

        // Couldn't parse - return empty frame
        stackFrame.getFunctionName = () => null;
        stackFrame.getFileName = () => line;
        stackFrame.getLineNumber = () => 0;
        stackFrame.getColumnNumber = () => 0;
        return stackFrame;
    });
}

cubeClient.interceptors.request.use(async (config, ...restArgs) => {
  const st = getStackFrame()

  console.info('CUBE DEPRECATED: ', config.params, st.slice(3).map(site => {
    return `at ${site.getFunctionName() || 'anonymous'} (${site.getFileName()}:${site.getLineNumber()}:${site.getColumnNumber()})`;
  }).join('\n'))
  const token = await firebaseauth.currentUser.getIdToken(false)

  config.headers["Authorization"] = `Bearer ${token}`

  return config
})

cubeClient.interceptors.response.use(response => {
  const responseData = JSON.parse(response.data)

  if (response.status !== 200) {
    throw new AxiosError(
      response.statusText || responseData.message,
      response.status.toString()
    )
  }

  return responseData
})

export default cubeClient
